import { Mic, Palette, Gamepad2, ListChecks } from 'lucide-react';

const days = [
  {
    day: 'Lunes',
    abbr: 'LUN',
    time: '22:30 – 01:00 hs',
    type: 'ASMR',
    color: 'from-rose-400/10 to-pink-400/5',
    border: 'border-rose-400/20 hover:border-rose-400/45',
    badge: 'bg-rose-400/15 text-rose-300',
    icon: <Mic className="w-5 h-5" />,
    title: 'ASMR + Canjes + Oráculo',
    description: 'Noche de canjes: sonidos relajantes con distintos elementos mientras conversamos. También saco cartas de oráculo para quienes lo pidan en el chat.',
    tags: ['Canjes ASMR', 'Cartas de oráculo', 'Chat con la comunidad'],
  },
  {
    day: 'Martes',
    abbr: 'MAR',
    time: '22:30 – 01:00 hs',
    type: 'ASMR',
    color: 'from-sky-400/10 to-blue-400/5',
    border: 'border-sky-400/20 hover:border-sky-400/45',
    badge: 'bg-sky-400/15 text-sky-300',
    icon: <Palette className="w-5 h-5" />,
    title: 'ASMR + Actividad Manual',
    description: 'Cerámica, pintura, rompecabezas, diamond painting, mandalas... cada semana trae una actividad artística diferente con el micrófono siempre presente.',
    tags: ['Cerámica', 'Pintura', 'Diamond painting', 'Mandalas'],
  },
  {
    day: 'Miércoles',
    abbr: 'MIÉ',
    time: '22:30 – 01:00 hs',
    type: 'ASMR',
    color: 'from-emerald-400/10 to-teal-400/5',
    border: 'border-emerald-400/20 hover:border-emerald-400/45',
    badge: 'bg-emerald-400/15 text-emerald-300',
    icon: <Palette className="w-5 h-5" />,
    title: 'ASMR + Actividad Manual',
    description: 'Continuamos con actividades manuales y artísticas. Un espacio de creación colectiva, en calma y con buena energía.',
    tags: ['Actividad artística', 'Relajación', 'Creatividad'],
  },
  {
    day: 'Jueves',
    abbr: 'JUE',
    time: '22:30 – 01:00 hs',
    type: 'ASMR Gaming',
    color: 'from-amber-400/10 to-orange-400/5',
    border: 'border-amber-400/20 hover:border-amber-400/45',
    badge: 'bg-amber-400/15 text-amber-300',
    icon: <Gamepad2 className="w-5 h-5" />,
    title: 'ASMR Gaming',
    description: 'Videojuegos relajantes en modo ASMR. La tranquilidad del ASMR se mezcla con el disfrute de juegos pausados y envolventes.',
    tags: ['Juegos relajantes', 'ASMR', 'Exploración'],
  },
  {
    day: 'Viernes',
    abbr: 'VIE',
    time: 'Al mediodía',
    type: 'Cowork',
    color: 'from-fuchsia-400/10 to-pink-400/5',
    border: 'border-fuchsia-400/20 hover:border-fuchsia-400/45',
    badge: 'bg-fuchsia-400/15 text-fuchsia-300',
    icon: <ListChecks className="w-5 h-5" />,
    title: 'Cowork — trabajamos juntos',
    description: 'Sesión para hacer los pendientes en compañía. Cargás tus tareas desde el chat, se ven en pantalla y las vamos completando al ritmo del pomodoro. Ideal para estudiar o laburar sin estar solo.',
    tags: ['Pomodoro', 'Tareas en pantalla', 'Foco compartido'],
  },
];

export default function Schedule() {
  return (
    <section className="relative bg-gradient-to-b from-[#0a0815] to-[#0d0a1a] py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sky-300/60 text-sm font-medium tracking-[0.2em] uppercase mb-3">Directos</p>
          <h2 className="text-4xl sm:text-5xl font-bold text-white/90">Horarios de stream</h2>
          <p className="mt-4 text-slate-400 text-base max-w-xl mx-auto">
            De lunes a jueves a las 22:30 hs y los viernes al mediodía (Argentina) — cada día con su
            propia propuesta.
          </p>
        </div>

        <div className="space-y-4">
          {days.map((d) => (
            <div
              key={d.day}
              className={`group flex flex-col sm:flex-row gap-6 p-6 rounded-2xl border bg-gradient-to-r ${d.color} ${d.border} transition-all duration-300 cursor-default`}
            >
              <div className="flex-shrink-0 flex flex-row sm:flex-col items-center sm:items-start gap-3 sm:gap-1 sm:w-24">
                <span className="text-2xl font-bold text-white/80">{d.abbr}</span>
                <span className="text-xs text-slate-400/60">{d.time}</span>
                <span className={`ml-auto sm:ml-0 mt-0 sm:mt-2 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${d.badge}`}>
                  {d.icon}
                  {d.type}
                </span>
              </div>
              <div className="hidden sm:block w-px bg-white/5" />
              <div className="flex-1">
                <h3 className="text-white/90 font-semibold text-lg mb-2">{d.title}</h3>
                <p className="text-slate-400/80 text-sm leading-relaxed mb-3">{d.description}</p>
                <div className="flex flex-wrap gap-2">
                  {d.tags.map((tag) => (
                    <span key={tag} className="text-xs px-2.5 py-1 rounded-full bg-white/5 text-slate-300/60 border border-white/5">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
